import useScrollAnimation from "@/hooks/useScrollAnimation";
import { whyChooseData } from "@/mocks/homeData";

export default function WhyChooseSection() {
  const { ref, isVisible } = useScrollAnimation(0.08);

  return (
    <section id="why-choose" className="w-full py-16 md:py-24 bg-background-100">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {whyChooseData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {whyChooseData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {whyChooseData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {whyChooseData.reasons.map((reason, index) => (
            <div
              key={reason.title}
              className={`bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all ${
                index === 0 ? "lg:col-span-3 bg-primary-50/30 border-primary-100" : ""
              }`}
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center mb-4 ${
                index === 0 ? "bg-primary-500 text-background-50" : "bg-primary-50"
              }`}>
                <i className={`${reason.icon} text-lg md:text-xl ${index === 0 ? "" : "text-primary-500"}`} />
              </div>
              <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">
                {reason.title}
              </h4>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}